import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import PropTypes from 'prop-types'

import { useDialog } from '@galo-monitor/dialog'
import forgotPasswordSchema from '@galo-monitor/forms/schemas/auth/forgotPassword.schema'
import I18n, { useT } from '@galo-monitor/i18n'
import { AuthenticationActions } from '@galo-monitor/stores/authentication'
import Button from '@galo-monitor/web-components/Button'
import Form from '@galo-monitor/web-components/Form'
import InputEmail from '@galo-monitor/web-components/InputEmail'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'
import LoadingModal from '@galo-monitor/web-containers/modals/LoadingModal'
import SuccessModal from '@galo-monitor/web-containers/modals/SuccessModal'
import { useRoutes } from '@galo-monitor/web-containers/routes/guest'

import { Container, Title } from './styles'

const ForgotPasswordForm = forwardRef((props, formRef) => {
  const { withoutSubmitButton, loading } = props

  const dispatch = useCallback(useDispatch(), [])
  const { createDialog, removeDialog } = useDialog()
  const t = useT()
  const history = useHistory()
  const { routes } = useRoutes()

  const handleSubmit = useCallback(
    ({ email }) => {
      createDialog({
        id: 'loading',
        Component: LoadingModal
      })

      const removeLoader = () => {
        setTimeout(() => removeDialog({ id: 'loading' }), 150)
      }

      dispatch(AuthenticationActions.forgotPassword(
        email,
        () => {
          removeLoader()
          createDialog({
            id: 'success',
            Component: SuccessModal,
            props: {
              title: t('request sent'),
              message: t('forgot success message')
            }
          })
          history.replace(routes.login.path)
        },
        () => {
          removeLoader()
          createDialog({
            id: 'error',
            Component: ErrorModal,
            props: {
              title: t('reset password error title'),
              message: t('reset password error message')
            }
          })
        }
      ))
    },
    [createDialog, dispatch, history, removeDialog, routes.login.path, t]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ forgotPasswordSchema }
      onSubmit={ handleSubmit }
    >
      <Container>
        <Title>
          <I18n>recover password</I18n>
        </Title>

        <InputEmail
          name="email"
          label="E-mail"
          disabled={ loading }
          fullWidth
        />

        {!withoutSubmitButton && (
          <Button
            id="forgot-password-submit"
            onClick={ () => formRef.current.submit() }
            disabled={ loading }
            fullWidth
          >
            <I18n>recover password</I18n>
          </Button>
        )}
      </Container>
    </Form>
  )
})

ForgotPasswordForm.propTypes = {
  loading: PropTypes.bool,
  // onSubmit: PropTypes.func,
  withoutSubmitButton: PropTypes.bool
}

ForgotPasswordForm.defaultProps = {
  loading: false,
  // onSubmit: () => {},
  withoutSubmitButton: false
}

export default ForgotPasswordForm
